{
  "title": "Documents",
  "subtitle": "Tous les tickets, factures, avoirs et rapports Z émis. Ouvrez-en un pour le lire ou l'imprimer.",
  "empty": {
    "title": "Aucun document émis pour l'instant",
    "text": "Les tickets, factures, avoirs et rapports Z apparaissent ici dès leur émission."
  },
  "tabs": {
    "all": "Tous",
    "receipt": "Tickets",
    "invoice": "Factures",
    "creditNote": "Avoirs",
    "zReport": "Rapports Z"
  },
  "list": {
    "search": "Numéro, commande, client, matricule fiscal, téléphone ou référence",
    "filters": "Filtres",
    "clear": "Effacer les filtres",
    "register": "Caisse",
    "allRegisters": "Toutes les caisses",
    "paymentMethod": "Mode de paiement",
    "allPaymentMethods": "Tous les modes de paiement",
    "issuedBy": "Émis par",
    "allPeople": "Émis par tous",
    "taxId": "Matricule fiscal de l'acheteur",
    "anyTaxId": "Avec ou sans matricule fiscal",
    "taxIds": {
      "with": "Avec matricule fiscal",
      "without": "Sans matricule fiscal"
    },
    "minTotal": "Montant de",
    "maxTotal": "Montant à",
    "noMatch": "Aucun document ne correspond à ces filtres.",
    "showing_one": "{{first}}–{{last}} sur {{total}} document",
    "showing_many": "{{first}}–{{last}} sur {{total}} documents",
    "showing_other": "{{first}}–{{last}} sur {{total}} documents",
    "amount": "Total {{amount}}"
  },
  "columns": {
    "document": "Document",
    "date": "Date",
    "buyer": "Client",
    "order": "Commande",
    "site": "Site",
    "by": "Émis par",
    "total": "Total (TND)"
  },
  "types": {
    "receipt": "Ticket",
    "invoice": "Facture",
    "creditNote": "Avoir",
    "zReport": "Rapport Z"
  },
  "document": {
    "immutable": "Un document émis ne change jamais. Les corrections passent par un avoir.",
    "print": "Imprimer",
    "taxId": "Matricule fiscal",
    "tradeRegister": "Registre du commerce",
    "date": "Date",
    "order": "Commande",
    "buyer": "Client",
    "counterSale": "Vente au comptoir",
    "corrects": "Corrige la facture",
    "reason": "Motif",
    "paymentMethod": "Mode de règlement",
    "columns": {
      "ref": "Réf.",
      "item": "Désignation",
      "quantity": "Qté",
      "unitPrice": "P.U. HT",
      "discount": "Rem.",
      "vat": "TVA",
      "total": "Total HT"
    },
    "refundLine": "Remboursement",
    "vatRate": "Taux de TVA",
    "vatBase": "Base HT",
    "vatAmount": "TVA",
    "discounts": "Remise",
    "shipping": "Frais de livraison",
    "net": "Total HT",
    "tax": "Total TVA",
    "total": "Total TTC",
    "stampDuty": "Timbre fiscal",
    "totalDue": "Net à payer",
    "totalCredit": "Montant de l’avoir",
    "amountsIn": "Montants en dinars tunisiens (TND).",
    "issuedBy": "Émis par {{name}}.",
    "correctsReceipt": "Corrige le ticket",
    "openOrder": "Commande {{number}}",
    "onlyTheDate": "Seule la date d’une facture peut changer. Toute autre correction passe par un avoir.",
    "changeDate": "Changer la date",
    "dateTitle": "Date de {{number}}",
    "dateHint": "Du {{from}} au {{to}}, pour que les dates suivent les numéros.",
    "dateChanged": "Date changée",
    "title": {
      "receipt": "Ticket de caisse",
      "invoice": "Facture",
      "creditNote": "Facture d’avoir"
    },
    "number": "N°",
    "tel": "Tél.",
    "reference": "Références",
    "customerCode": "Code client",
    "orderDate": "Date de commande",
    "datedOn": "du {{date}}",
    "gross": "Total brut HT",
    "netAfter": "Total net HT",
    "inWords": {
      "invoice": "Arrêtée la présente facture à la somme de :",
      "creditNote": "Arrêté le présent avoir à la somme de :",
      "receipt": "Arrêté le présent ticket à la somme de :"
    },
    "stamp": "Cachet et signature",
    "bank": "Banque",
    "rib": "RIB",
    "colon": " : "
  },
  "print": {
    "title": "Options d’impression",
    "subtitle": "Réglées dans Configuration. Ce que vous changez ici ne vaut que pour cette impression.",
    "reset": "Revenir aux réglages",
    "print": "Imprimer",
    "kinds": {
      "invoice": "Factures et avoirs",
      "deliveryNote": "Bons de livraison"
    },
    "parts": {
      "company": "Entreprise",
      "references": "Références",
      "customer": "Client",
      "table": "Tableau",
      "totals": "Totaux",
      "foot": "Bas de page"
    },
    "options": {
      "logo": "Logo",
      "tradeName": "Nom commercial",
      "contact": "Téléphone et email",
      "sellerTaxId": "Matricule fiscal",
      "tradeRegister": "Registre du commerce",
      "customerCode": "Code client",
      "orderNumber": "N° de commande",
      "orderDate": "Date de commande",
      "paymentMethod": "Mode de règlement",
      "deliveryBox": "Cadre Livraison entier",
      "deliveryMode": "Mode de livraison",
      "carrier": "Transporteur",
      "tracking": "N° de suivi",
      "buyerContact": "Téléphone et email du client",
      "buyerPhone": "Téléphone du client",
      "buyerTaxId": "Matricule fiscal du client",
      "refColumn": "Colonne Réf.",
      "unitPriceColumn": "Colonne P.U. HT",
      "discountColumn": "Colonne Remise",
      "vatColumn": "Colonne TVA",
      "promotions": "Nom des promotions",
      "remarks": "Observations de la commande",
      "discountDetail": "Total brut et remise",
      "amountInWords": "Montant en lettres",
      "signature": "Cadre cachet et signature",
      "senderSignature": "Cachet et signature de l’expéditeur",
      "receiverSignature": "Signature du destinataire",
      "amountsNote": "Mention de la devise",
      "issuedBy": "Émis par",
      "legalFooter": "Coordonnées en bas de page",
      "bankDetails": "Banque et RIB"
    }
  }
}
